import DefaultLogo from '@/assets/images/logos/default-logo.png';
import HorizontalAvenueLogo from '@/assets/images/logos/horizontal/avenuel-logo.png';
import HorizontalMallLogo from '@/assets/images/logos/horizontal/mall-logo.png';
import HorizontalOutletLogo from '@/assets/images/logos/horizontal/outlet-logo.png';
import HorizontalPremiumOutletLogo from '@/assets/images/logos/horizontal/premium-outlet-logo.png';
import HorizontalShoppingMallLogo from '@/assets/images/logos/horizontal/shopping-mall-logo.png';
import HorizontalYoungPlazaLogo from '@/assets/images/logos/horizontal/young-plaza-logo.png';

// VERTICAL CONTRAST
import ContrastVerticalAvenueLogo from '@/assets/images/logos/vertical/contrast/avenuel-logo.png';
import ContrastVerticalMallLogo from '@/assets/images/logos/vertical/contrast/mall-logo.png';
import ContrastVerticalOutletLogo from '@/assets/images/logos/vertical/contrast/outlet-logo.png';
import ContrastVerticalPremiumOutletLogo from '@/assets/images/logos/vertical/contrast/premium-outlet-logo.png';
import ContrastVerticalShoppingMallLogo from '@/assets/images/logos/vertical/contrast/shopping-mall-logo.png';
import ContrastVerticalYoungPlazaLogo from '@/assets/images/logos/vertical/contrast/young-plaza-logo.png';

// VERTICAL NORMAL
import NormalVerticalAvenueLogo from '@/assets/images/logos/vertical/normal/avenuel-logo.png';
import NormalVerticalMallLogo from '@/assets/images/logos/vertical/normal/mall-logo.png';
import NormalVerticalOutletLogo from '@/assets/images/logos/vertical/normal/outlet-logo.png';
import NormalVerticalPremiumOutletLogo from '@/assets/images/logos/vertical/normal/premium-outlet-logo.png';
import NormalVerticalShoppingMallLogo from '@/assets/images/logos/vertical/normal/shopping-mall-logo.png';
import NormalVerticalYoungPlazaLogo from '@/assets/images/logos/vertical/normal/young-plaza-logo.png';
import { BuildingNameType } from '@/enums/building';

// HORIZONTAL
import splittedHorizontalMallLogo from '@/assets/images/logos/horizontal/normal/split/mall-logo.png';
import splittedHorizontalOutletLogo from '@/assets/images/logos/horizontal/normal/split/outlet-logo.png';
import splittedHorizontalAvenueLogo from '@/assets/images/logos/horizontal/normal/split/avenuel-logo.png';
import splittedHorizontalYoungPlazaLogo from '@/assets/images/logos/horizontal/normal/split/young-plaza-logo.png';

type ScreenMode = 'split' | 'fullscreen';

type ScreenModeLogo = Record<ScreenMode, Record<BuildingNameType, string>>;
type ThemeModeLogo = Record<'normal' | 'contrast', ScreenModeLogo>;
type LogoMap = Record<'horizontal' | 'vertical', ThemeModeLogo>;

const LOGO_MAP: LogoMap = {
    horizontal: {
        normal: {
            split: {
                [BuildingNameType.MALL]: splittedHorizontalMallLogo,
                [BuildingNameType.OUTLET]: splittedHorizontalOutletLogo,
                [BuildingNameType.PREMIUM_OUTLET]: ContrastVerticalPremiumOutletLogo,
                [BuildingNameType.AVENUEL]: splittedHorizontalAvenueLogo,
                [BuildingNameType.YOUNG_PLAZA]: splittedHorizontalYoungPlazaLogo,
                [BuildingNameType.SHOPPING_MALL]: ContrastVerticalShoppingMallLogo,
            },
            fullscreen: {
                [BuildingNameType.MALL]: HorizontalMallLogo,
                [BuildingNameType.OUTLET]: HorizontalOutletLogo,
                [BuildingNameType.PREMIUM_OUTLET]: HorizontalPremiumOutletLogo,
                [BuildingNameType.AVENUEL]: HorizontalAvenueLogo,
                [BuildingNameType.YOUNG_PLAZA]: HorizontalYoungPlazaLogo,
                [BuildingNameType.SHOPPING_MALL]: HorizontalShoppingMallLogo,
            },
        },
        contrast: {
            split: {
                [BuildingNameType.MALL]: splittedHorizontalMallLogo,
                [BuildingNameType.OUTLET]: splittedHorizontalOutletLogo,
                [BuildingNameType.PREMIUM_OUTLET]: ContrastVerticalPremiumOutletLogo,
                [BuildingNameType.AVENUEL]: ContrastVerticalAvenueLogo,
                [BuildingNameType.YOUNG_PLAZA]: ContrastVerticalYoungPlazaLogo,
                [BuildingNameType.SHOPPING_MALL]: ContrastVerticalShoppingMallLogo,
            },
            fullscreen: {
                [BuildingNameType.MALL]: HorizontalMallLogo,
                [BuildingNameType.OUTLET]: HorizontalOutletLogo,
                [BuildingNameType.PREMIUM_OUTLET]: HorizontalPremiumOutletLogo,
                [BuildingNameType.AVENUEL]: HorizontalAvenueLogo,
                [BuildingNameType.YOUNG_PLAZA]: HorizontalYoungPlazaLogo,
                [BuildingNameType.SHOPPING_MALL]: HorizontalShoppingMallLogo,
            },
        },
    },
    vertical: {
        normal: {
            split: {
                [BuildingNameType.MALL]: NormalVerticalMallLogo,
                [BuildingNameType.OUTLET]: NormalVerticalOutletLogo,
                [BuildingNameType.PREMIUM_OUTLET]: NormalVerticalPremiumOutletLogo,
                [BuildingNameType.AVENUEL]: NormalVerticalAvenueLogo,
                [BuildingNameType.YOUNG_PLAZA]: NormalVerticalYoungPlazaLogo,
                [BuildingNameType.SHOPPING_MALL]: NormalVerticalShoppingMallLogo,
            },
            fullscreen: {
                [BuildingNameType.MALL]: NormalVerticalMallLogo,
                [BuildingNameType.OUTLET]: NormalVerticalOutletLogo,
                [BuildingNameType.PREMIUM_OUTLET]: NormalVerticalPremiumOutletLogo,
                [BuildingNameType.AVENUEL]: NormalVerticalAvenueLogo,
                [BuildingNameType.YOUNG_PLAZA]: NormalVerticalYoungPlazaLogo,
                [BuildingNameType.SHOPPING_MALL]: NormalVerticalShoppingMallLogo,
            },
        },
        contrast: {
            split: {
                [BuildingNameType.MALL]: ContrastVerticalMallLogo,
                [BuildingNameType.OUTLET]: ContrastVerticalOutletLogo,
                [BuildingNameType.PREMIUM_OUTLET]: ContrastVerticalPremiumOutletLogo,
                [BuildingNameType.AVENUEL]: ContrastVerticalAvenueLogo,
                [BuildingNameType.YOUNG_PLAZA]: ContrastVerticalYoungPlazaLogo,
                [BuildingNameType.SHOPPING_MALL]: ContrastVerticalShoppingMallLogo,
            },
            fullscreen: {
                [BuildingNameType.MALL]: ContrastVerticalMallLogo,
                [BuildingNameType.OUTLET]: ContrastVerticalOutletLogo,
                [BuildingNameType.PREMIUM_OUTLET]: ContrastVerticalPremiumOutletLogo,
                [BuildingNameType.AVENUEL]: ContrastVerticalAvenueLogo,
                [BuildingNameType.YOUNG_PLAZA]: ContrastVerticalYoungPlazaLogo,
                [BuildingNameType.SHOPPING_MALL]: ContrastVerticalShoppingMallLogo,
            },
        },
    },
};

export const DEFAULT_FALLBACK_LOGO_URL = DefaultLogo;

export const getLogoUrl = (isHorizontal: boolean, buildingType?: BuildingNameType, isContrastMode: boolean = false, screenMode: ScreenMode = 'fullscreen') => {
    if (!buildingType) return undefined;
    const logoMap = isHorizontal ? LOGO_MAP.horizontal : LOGO_MAP.vertical;
    return logoMap[isContrastMode ? 'contrast' : 'normal'][screenMode][buildingType] || undefined;
};
